import { ChangeDetectionStrategy, Component, input, output, viewChild } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { ChevronState, RotatingChevronComponent } from '../rotating-chevron/rotating-chevron.component';
import { TagComponent } from '../tag/tag.component';

export interface SkillLevelTagOption {
  value: string;
  label: string;
}

@Component({
  selector: 'ct-lib-skill-level-tag',
  templateUrl: './skill-level-tag.component.html',
  styleUrls: ['./skill-level-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, DropdownComponent, RotatingChevronComponent, TagComponent],
})
export class SkillLevelTagComponent {
  readonly ChevronState = ChevronState;

  readonly name = input('');
  readonly levelLabel = input.required<string>();
  readonly options = input.required<SkillLevelTagOption[]>();
  readonly selectedValue = input.required<string>();
  readonly deletable = input(true);

  readonly levelChange = output<string>();
  readonly deleted = output<void>();

  readonly dropdown = viewChild(DropdownComponent);

  /**
   * Updates the skill level and closes the dropdown.
   * @param value - Selected skill level value
   */
  selectLevel(value: string): void {
    this.levelChange.emit(value);
  }

  /**
   * Removes the skill without toggling the level dropdown.
   */
  onDelete(): void {
    this.dropdown()?.close();
    this.deleted.emit();
  }
}
